import type { Vulnerability } from '../types/vulnerability'

/**
 * Export utilities for vulnerability data
 */

export function exportToCSV(data: Vulnerability[], filename: string = 'vulnerabilities'): void {
  const headers = [
    'CVE',
    'Severity',
    'CVSS',
    'Package Name',
    'Package Version',
    'Package Type',
    'Group Name',
    'Image Name',
    'Image Version',
    'Analysis Status',
    'Risk Factors',
    'Description',
    'Published',
    'Fix Date',
    'Link',
  ]

  const rows = data.map((v) => [
    v.cve,
    v.severity,
    v.cvss.toString(),
    v.packageName,
    v.packageVersion,
    v.packageType,
    v.groupName,
    v.imageName,
    v.imageVersion,
    v.kaiStatus || '',
    v.riskFactors.join('; '),
    escapeCSV(v.description),
    v.published,
    v.fixDate || '',
    v.link,
  ])

  const csvContent = [
    headers.join(','),
    ...rows.map((row) => row.map((cell) => `"${cell}"`).join(',')),
  ].join('\n')

  downloadFile(csvContent, `${filename}.csv`, 'text/csv')
}

export function exportToJSON(data: Vulnerability[], filename: string = 'vulnerabilities'): void {
  const jsonContent = JSON.stringify(data, null, 2)
  downloadFile(jsonContent, `${filename}.json`, 'application/json')
}

function escapeCSV(str: string): string {
  if (!str) return ''
  // Replace double quotes with two double quotes and remove newlines
  return str.replace(/"/g, '""').replace(/\n/g, ' ').replace(/\r/g, '')
}

function downloadFile(content: string, filename: string, mimeType: string): void {
  const blob = new Blob([content], { type: mimeType })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export function getExportFilename(): string {
  const date = new Date().toISOString().split('T')[0]
  return `vulnerabilities-${date}`
}
